<template>
  <div>
    <div class="d-flex justify-content-between align-items-end mb-3">
      <h3 class="mb-0">Histórico de Upload</h3>
      <div style="min-width: 250px;">
        <b-form-select
          v-model="selectedType"
          :options="typeOptions"
          size="sm"
        />
      </div>
    </div>

    <div v-if="isLoading" class="text-center my-3">
      <b-spinner class="align-middle"></b-spinner>
      <strong class="ml-2">Carregando dados...</strong>
    </div>

    <div v-else-if="formattedHistory.length === 0" class="text-center my-3">
      {{ noDataMessage || "Nenhum registro encontrado" }}
    </div>
    <b-table
      v-else
      :items="formattedHistory"
      :current-page="currentPage"
      :fields="fields"
      :per-page="10"
      bordered
      hover
      small
      responsive
    >
      <template #cell(date)="data">
        {{ formatDate(data.item.date) }}
      </template>

      <template #cell(time)="data">
        {{ formatTime(data.item.date) }}
      </template>
    </b-table>

    <b-pagination
      v-if="history.length"
      v-model="currentPage"
      :total-rows="history.length"
      :per-page="10"
      align="center"
      size="md"
      class="mt-3"
    />
  </div>
</template>

<script>
import { BTable, BPagination, BSpinner, BFormSelect } from "bootstrap-vue";

export default {
  name: "UploadHistory",

  components: {
    BTable,
    BPagination,
    BSpinner,
    BFormSelect,
  },

  props: {
    history: Array,
    isLoading: Boolean,
    noDataMessage: String,
  },

  data() {
    return {
    currentPage: 1,
    selectedType: null,
      fields: [
        { key: "date", label: "Data", class: "text-center" , sortable: true},
        { key: "time", label: "Hora", class: "text-center" },
        { key: "name", label: "Nome", class: "text-center", sortable: true },
        { key: "type", label: "Tipo", class: "text-center" },
      ],
    };
  },

  computed: {
    typeOptions() {
      const types = this.history.map(item => item.conciliation_type);

      const unique = [...new Set(types)];

      return [
        { value: null, text: "Todos" },
        ...unique.map(type => ({
          value: type,
          text: type
        }))
      ];
    },

  formattedHistory() {
    if (!Array.isArray(this.history)) return [];

    let data = this.history;

    if (this.selectedType) {
      data = data.filter(
        item => item.conciliation_type === this.selectedType
      );
    }

    return data.map((item) => ({
      date: item.date,
      time: item.date,
      name: item.file_name,
      type: item.conciliation_type,
    }));
  }
  },

  methods: {
    formatDate(date) {
      return new Date(date).toLocaleDateString();
    },

    formatTime(date) {
      return new Date(date).toLocaleTimeString();
    },

    getVariant(type) {
      const map = {
        arquivos: "primary",
        polishop: "success",
        equals: "warning",
        boaVista: "danger",
      };

      return map[type] || "secondary";
    },
  },
};
</script>